module.exports = __webpack_public_path__ + "static/media/camila.152bef28.png";